<template>
    <div class="exam__sidebar  exam__sidebar--bg-blue" :class="{'exam__sidebar--fixed':$store.getters['candidate/getCurrentTesting'] && $store.getters['candidate/getCurrentTesting'].questionSettings && $store.getters['candidate/getCurrentTesting'].questionSettings.optionValue===QUESTION_SETTINGS_ALL}">

        <div v-if="$route.name !== 'candidate.results'" class="exam__sidebar-header">
            <div class="exam__sidebar-logo">
                <LogoComponent />
            </div>
        </div>

        <div class="exam__sidebar-body">

            <div class="exam__data-group">
                <timer-component v-if="$store.getters['candidate/isTimerEnabled']" :is-testing="true" @over="finishTest($event)" :duration-start="testStartDuration" :duration-finish="testFinishDuration" />
            </div>
            <button class="exam__toggle-btn  collapse-btn" :class="{' collapse-btn--active':showInfo}" @click="showInfo=!showInfo">

                <span class="collapse-btn__text">{{getTranslation('aboutTesting')}}</span>

                <span class="collapse-btn__icon-wrap">
                    <svg class="collapse-btn__icon" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.297.373C.733-.081 1.49-.127 1.99.27L6 3.46 10.01.27c.498-.397 1.257-.35 1.693.103.437.453.386 1.142-.113 1.539L6.79 5.73c-.452.36-1.128.36-1.58 0L.41 1.912C-.09 1.515-.14.826.297.372z" />
                    </svg>
              </span>

            </button>

            <div v-if="showInfo" class="exam__data">
                <div v-if="POSITION_RESOURCES.includes($store.getters['candidate/getCurrentApp'].resource.type.id)" class="exam__data-group">

                    <div class="exam__data-label">{{ getTranslation('position') }}</div>


                    <div class="exam__data-value">{{ $store.getters['candidate/getCurrentApp'].resource.title }}</div>

                </div>

              <div v-if="$store.getters['candidate/getCurrentApp'].resource.type.id === RESOURCE_REGISTER_POST_ID || $store.getters['candidate/getCurrentApp'].resource.type.id === RESOURCE_MRK_ID " class="exam__data-group">

                <div class="exam__data-label">{{ getTranslation('position') }}</div>


                <div class="exam__data-value">{{ $store.getters['candidate/getCurrentApp'].resource.resourceTitle }}</div>

              </div>

              <div v-if="$store.getters['candidate/getCurrentApp'].resource.postScopeText" class="exam__data-group">

                <div class="exam__data-label">{{ getTranslation('postScope') }}</div>


                <div class="exam__data-value">{{ getTranslation($store.getters['candidate/getCurrentApp'].resource.postScopeText) }}</div>

              </div>

                <div v-else class="exam__data-group">
                    <div class="exam__data-label">{{ getTranslation('category') }}</div>
                    <div class="exam__data-value">{{ $store.getters['candidate/getCurrentApp'].resource.resourceTitle }}</div>
                </div>

                <div class="exam__data-group">
                    <div class="exam__data-label">{{ getTranslation('testType') }}</div>
                    <div class="exam__data-value">{{ $store.getters['candidate/getCurrentTesting'].testingTypeText }}</div>
                </div>
                <div class="exam__data-group">
                    <div class="exam__data-label">{{ getTranslation('namingNPA') }}</div>
                    <div class="exam__data-value npaNaming">
                        {{ $store.getters['candidate/getCurrentNpa'] }}
                    </div>
                </div>

                <div v-if="!$store.getters['candidate/getCurrentApp'].demo" class="exam__data-group">
                    <div class="exam__data-label">{{getTranslation('testingTime')}}</div>
                    <div v-if="!$store.getters['candidate/hasActiveTesting'] && $store.getters['candidate/getCandidateEvent']" class="exam__data-value">
                        {{momentFormatDate($store.getters['candidate/getCandidateEvent'].startTime,'DD.MM.YYYY')}},&nbsp;
                        {{momentFormatDate($store.getters['candidate/getCandidateEvent'].startTime,'HH:mm')}} — {{momentFormatDate($store.getters['candidate/getCandidateEvent'].endTime,'HH:mm')}}
                    </div>
                    <div v-if="$store.getters['candidate/hasActiveTesting']" class="exam__data-value">
                        {{momentFormatDate($store.getters['candidate/getCurrentEvent'].startTime,'HH:mm')}} — {{momentFormatDate($store.getters['candidate/getCurrentEvent'].endTime,'HH:mm')}}
                    </div>
                </div>
            </div>


            <div class="exam__actions">
                <a v-if="$store.getters['candidate/hasActiveTesting']" class="btn  btn--full-width"
                   :class="{'btn--danger':$store.getters['candidate/answerCount'] < $store.getters['candidate/getQuestionCount'],'btn--success': $store.getters['candidate/answerCount'] === $store.getters['candidate/getQuestionCount'] && $store.getters['candidate/getQuestionCount'] !== 0}"
                   @click="finishTest" href="javascript:void(0)">
                    {{ getTranslation('finishTest') }}
                </a>
            </div>

        </div>

    </div>
    <!-- /.exam-sidebar  -->
</template>

<script>
    import TimerComponent from "../../../components/TimerComponent";
    import LogoComponent from "./components/LogoComponent";
    import testMixin from "../testing/mixins/test";


    export default {
        name: "Sidebar",
        components: { LogoComponent, TimerComponent },
        mixins: [testMixin],
        data() {
            return {
                showInfo: true,
                testTime: '',
            }
        },
        computed: {
            testStartDuration() {
                return this.$store.getters['candidate/getCurrentTesting'].durationStart;
            },
            testFinishDuration() {
                return this.$store.getters['candidate/getCurrentTesting'].durationFinish;
            }
        }
    }
</script>

<style scoped>
    .exam__sidebar {
        width: 200px !important;
    }

    .npaNaming {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5; /* number of lines to show */
        -webkit-box-orient: vertical;
    }
</style>
